import { Edit, useForm } from "@refinedev/antd";
import { Form, Select, InputNumber, Switch, Input, Alert, Space } from "antd";
import type { User } from "@/lib/types";

type AdminUser = User & { banned?: boolean; nome?: string | null };

/**
 * /admin/users/:id/edit — editar plano/quota/flags (PATCH /admin/users/:id).
 *
 * Como obtém os dados (MOCK MODE): `useForm` carrega o registro via getOne e o
 * submit faz update (merge em memória no mockDataProvider). Campos editáveis
 * pelo suporte/admin; alterar plano/quota afeta faturamento e limite freemium,
 * por isso a API deve auditar (audit_log) cada mudança.
 */
export const UserEdit: React.FC = () => {
  const { formProps, saveButtonProps } = useForm<AdminUser>();

  return (
    <Edit saveButtonProps={saveButtonProps} title="Editar conta">
      <Alert
        type="warning"
        showIcon
        style={{ marginBottom: 16 }}
        message="Ação administrativa sensível"
        description="Alterações de plano, quota ou banimento afetam o faturamento e o acesso do usuário. A API registra cada mudança no audit log."
      />
      <Form {...formProps} layout="vertical">
        <Form.Item label="Nome" name="nome">
          <Input style={{ maxWidth: 380 }} placeholder="Nome do usuário" />
        </Form.Item>
        <Space size={16} wrap>
          <Form.Item label="Role" name="role">
            <Select
              style={{ width: 180 }}
              options={[
                { value: "user", label: "user" },
                { value: "admin", label: "admin" },
              ]}
            />
          </Form.Item>
          <Form.Item label="Plano" name="plano">
            <Select
              style={{ width: 180 }}
              options={[
                { value: "free", label: "free" },
                { value: "premium", label: "premium" },
              ]}
            />
          </Form.Item>
          <Form.Item label="Tipo de cobrança" name="tipo_cobranca">
            <Select
              style={{ width: 180 }}
              options={[
                { value: "none", label: "none" },
                { value: "monthly", label: "monthly" },
                { value: "annual", label: "annual" },
              ]}
            />
          </Form.Item>
        </Space>
        <Space size={16} wrap>
          <Form.Item label="Registros no mês" name="registros_mes">
            <InputNumber min={0} style={{ width: 180 }} />
          </Form.Item>
          <Form.Item label="Registros extras" name="registros_extras">
            <InputNumber min={0} style={{ width: 180 }} />
          </Form.Item>
          <Form.Item
            label="E-mail semanal"
            name="weekly_email"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
          <Form.Item label="Banido" name="banned" valuePropName="checked">
            <Switch checkedChildren="banido" unCheckedChildren="ativo" />
          </Form.Item>
        </Space>
      </Form>
    </Edit>
  );
};
